import { ConnectedResourceGuard, ResourcesDriveGuard } from "./dashboard-experimental-guards";

type ResourcesLibraryRouteElementsOptions = {
  AllModelsNew: React.ComponentType;
  ResourcesDrive: React.ComponentType;
};

export function createResourcesLibraryRouteElements({
  AllModelsNew,
  ResourcesDrive,
}: ResourcesLibraryRouteElementsOptions) {
  const resourcesPage = (
    <ConnectedResourceGuard>
      <AllModelsNew />
    </ConnectedResourceGuard>
  );

  const resourcesDrivePage = (
    <ResourcesDriveGuard>
      <ConnectedResourceGuard>
        <ResourcesDrive />
      </ConnectedResourceGuard>
    </ResourcesDriveGuard>
  );

  return { resourcesPage, resourcesDrivePage };
}
